<app-header class="layout-header" [menuToggleEnabled]="false" (menuToggle)="menuOpened = !menuOpened" [title]="title"></app-header>

@if (showMenu) {
    <dx-drawer
        class="layout-body"
        position="before"
        [closeOnOutsideClick]="shaderEnabled"
        [openedStateMode]="menuMode"
        [revealMode]="menuRevealMode"
        [minSize]="showMenu ? minMenuSize : 0"
        [maxSize]="showMenu ? 250 : 0"
        [shading]="showMenu ? shaderEnabled : false"
        [(opened)]="menuOpened"
    >
        @if (showMenu) {
            <app-side-navigation-menu
                [compactMode]="!menuOpened"
                [selectedItem]="selectedRoute"
                class="dx-swatch-additional"
                *dxTemplate="let dataMenu of 'panel'"
                (selectedItemChanged)="navigationChanged($event)"
                (openMenu)="navigationClick()"
            >
            </app-side-navigation-menu>
        }

        <div class="content">
            <!-- <app-breadcrumbs></app-breadcrumbs> -->
            <router-outlet></router-outlet>
        </div>
    </dx-drawer>
} @else {
    <div class="content">
        <router-outlet></router-outlet>
    </div>
}
